import {
  AteI18nService,
  AteEditorConfig,
  ATE_DEFAULT_TOOLBAR_CONFIG,
  AteTranslations,
} from '@flogeez/angular-tiptap-editor';
import { Extension } from '@tiptap/core';
import { delay, of, tap } from 'rxjs';

export function formatDateFromBack(date:any){
  let arr = date.split('-');
  return new Date(+arr[0],+arr[1]-1,+arr[2]);
}

export function formatDateToBack(date:any){
  let d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2)
    month = '0' + month;
  if (day.length < 2)
    day = '0' + day;

  return [year, month, day].join('-');
}

export function compareDate(deadline:any){
  let date1 = formatDateFromBack(deadline).getTime();
  let date2 = new Date().setHours(0,0,0,0);
  return (date2-date1)>0


}

export function GetTagsListFromArray(array:any){
  const arr = [];
  for(const item of array){
    arr.push(...item['tags']||[])
  }
  return [...new Set(arr)]



}




export const RU_TRANSLATIONS: Partial<AteTranslations> = {
  toolbar: {
    bold: 'Жирный',
    italic: 'Курсив',
    underline: 'Подчёркнутый',
    strike: 'Зачёркнутый',
    code: 'Код',
    codeBlock: 'Блок кода',
    superscript: 'Надстрочный',
    subscript: 'Подстрочный',
    highlight: 'Выделение',
    highlightPicker: 'Цвет фона',
    heading1: 'Заголовок 1',
    heading2: 'Заголовок 2',
    heading3: 'Заголовок 3',
    bulletList: 'Маркированный список',
    orderedList: 'Нумерованный список',
    blockquote: 'Цитата',
    alignLeft: 'По левому краю',
    alignCenter: 'По центру',
    alignRight: 'По правому краю',
    alignJustify: 'По ширине',
    link: 'Добавить ссылку',
    image: 'Добавить изображение',
    horizontalRule: 'Горизонтальная линия',
    table: 'Вставить таблицу',
    undo: 'Отменить',
    redo: 'Повторить',
    clear: 'Очистить',
    textColor: 'Цвет текста',
    customColor: 'Свой цвет',
    presets: 'Пресеты',
  },
  bubbleMenu: {
    bold: 'Жирный',
    italic: 'Курсив',
    underline: 'Подчёркнутый',
    strike: 'Зачёркнутый',
    code: 'Код',
    superscript: 'Надстрочный',
    subscript: 'Подстрочный',
    highlight: 'Выделение',
    highlightPicker: 'Цвет фона',
    textColor: 'Цвет текста',
    link: 'Ссылка',
    addLink: 'Добавить ссылку',
    editLink: 'Изменить ссылку',
    removeLink: 'Удалить ссылку',
    linkUrl: 'URL ссылки',
    linkText: 'Текст ссылки',
    openLink: 'Открыть ссылку',
    customColor: 'Свой цвет',
    presets: 'Пресеты',
  },
  slashCommands: {
    heading1: {
      title: 'Заголовок 1',
      description: 'Крупный заголовок раздела',
      keywords: ['заголовок', 'h1', 'title', '1', 'header'],
    },
    heading2: {
      title: 'Заголовок 2',
      description: 'Заголовок подраздела',
      keywords: ['заголовок', 'h2', 'title', '2', 'header'],
    },
    heading3: {
      title: 'Заголовок 3',
      description: 'Мелкий заголовок',
      keywords: ['заголовок', 'h3', 'title', '3', 'header'],
    },
    bulletList: {
      title: 'Маркированный список',
      description: 'Создать маркированный список',
      keywords: ['список', 'марки', 'ul', 'буллеты'],
    },
    orderedList: {
      title: 'Нумерованный список',
      description: 'Создать нумерованный список',
      keywords: ['список', 'нумерация', 'ol', 'ordered'],
    },
    blockquote: {
      title: 'Цитата',
      description: 'Добавить цитату',
      keywords: ['цитата', 'quote', 'blockquote'],
    },
    code: {
      title: 'Блок кода',
      description: 'Добавить блок кода',
      keywords: ['код', 'code', 'codeblock', 'pre'],
    },
    image: {
      title: 'Изображение',
      description: 'Вставить изображение',
      keywords: ['изображение', 'картинка', 'фото', 'img'],
    },
    horizontalRule: {
      title: 'Горизонтальная линия',
      description: 'Добавить разделительную линию',
      keywords: ['линия', 'разделитель', 'hr', 'rule'],
    },
    table: {
      title: 'Таблица',
      description: 'Вставить таблицу',
      keywords: ['таблица', 'table', 'grid', 'строки', 'столбцы'],
    },
  },
  table: {
    addRowBefore: 'Добавить строку выше',
    addRowAfter: 'Добавить строку ниже',
    deleteRow: 'Удалить строку',
    addColumnBefore: 'Добавить столбец слева',
    addColumnAfter: 'Добавить столбец справа',
    deleteColumn: 'Удалить столбец',
    deleteTable: 'Удалить таблицу',
    toggleHeaderRow: 'Строка заголовка',
    toggleHeaderColumn: 'Столбец заголовка',
    mergeCells: 'Объединить ячейки',
    splitCell: 'Разделить ячейку',
  },
  imageUpload: {
    selectImage: 'Выбрать изображение',
    loadError: 'Ошибка загрузки изображения',
    uploadingImage: 'Загрузка изображения...',
    uploadProgress: 'Прогресс загрузки',
    uploadError: 'Ошибка загрузки',
    uploadSuccess: 'Загрузка выполнена',
    imageTooLarge: 'Изображение слишком большое',
    invalidFileType: 'Недопустимый тип файла',
    dragDropText: 'Перетащите изображения сюда',
    changeImage: 'Заменить изображение',
    deleteImage: 'Удалить изображение',
    resizeSmall: 'Маленький',
    resizeMedium: 'Средний',
    resizeLarge: 'Большой',
    resizeOriginal: 'Оригинал',
    resizing: 'Изменение размера...',
    compressing: 'Сжатие...',
    compressionError: 'Ошибка сжатия',
    validating: 'Проверка файла...',
    uploadingToServer: 'Отправка на сервер...',
    replacingImage: 'Замена изображения...',
    insertingImage: 'Вставка в редактор...',
    noFileSelected: 'Файл не выбран',
    selectionCancelled: 'Выбор отменён',
    downloadImage: 'Скачать изображение',
    alignLeft: 'По левому краю',
    alignCenter: 'По центру',
    alignRight: 'По правому краю',
  },
  editor: {
    placeholder: 'Начните ввод...',
    character: 'символ',
    word: 'слово',
    linkPrompt: 'Введите URL ссылки',
    linkUrlPrompt: 'Введите URL',
    confirmDelete: 'Вы уверены, что хотите удалить?',
    toggleEdit: 'Режим редактирования',
    viewMode: 'Режим просмотра',
  },
  common: {
    cancel: 'Отмена',
    confirm: 'Подтвердить',
    apply: 'Применить',
    delete: 'Удалить',
    save: 'Сохранить',
    close: 'Закрыть',
    loading: 'Загрузка',
    error: 'Ошибка',
    success: 'Успешно',
  },
};

/**
 * Расширение TipTap, которое перехватывает getHTML() и заменяет
 * пустые параграфы <p></p> на <p>&nbsp;</p>, чтобы пустые строки
 * сохранялись при отображении через innerHTML.
 */
const EmptyParagraphPreserver = Extension.create({
  name: 'emptyParagraphPreserver',
  onCreate() {
    const originalGetHTML = this.editor.getHTML.bind(this.editor);
    this.editor.getHTML = () => {
      if(originalGetHTML().replace(/<p><\/p>/g, '').length === 0) return '';
      return originalGetHTML().replace(/<p><\/p>/g, '<p>&nbsp;</p>');
    };
  },
});

/**
 * Converts CKEditor5's legacy highlight format
 *   <span style="background-color:rgb(...)">text</span>
 * into TipTap's expected format
 *   <span ...><mark class="ate-highlight" data-color="..." style="background-color:...; color:inherit">text</mark></span>
 *
 * Only targets spans with a real (non-transparent) background-color.
 */
function migrateCKEditorHighlights(html: string): string {
  if (!html || !html.includes('background-color')) return html;

  const doc = new DOMParser().parseFromString(html, 'text/html');
  let changed = false;

  doc.querySelectorAll('span[style]').forEach((span) => {
    const el = span as HTMLElement;
    const bg = el.style.backgroundColor;
    if (!bg || bg === 'transparent' || bg === 'rgba(0, 0, 0, 0)') return;

    const mark = doc.createElement('mark');
    mark.className = 'ate-highlight';
    mark.setAttribute('data-color', bg);
    mark.style.backgroundColor = bg;
    mark.style.color = 'inherit';

    while (el.firstChild) {
      mark.appendChild(el.firstChild);
    }
    el.appendChild(mark);
    el.style.removeProperty('background-color');
    changed = true;
  });

  return changed ? doc.body.innerHTML : html;
}

/**
 * TipTap Extension that automatically converts CKEditor5's legacy
 * <span style="background-color:..."> into <mark> tags before parsing.
 *
 * - onBeforeCreate: preprocesses the initial content (before ProseMirror
 *   parses it via createDoc)
 * - onCreate: patches commands.setContent so any future content updates
 *   (e.g. loading from API) are also preprocessed
 */
const CKEditorHighlightMigration = Extension.create({
  name: 'ckEditorHighlightMigration',

  onBeforeCreate() {
    const content = this.editor.options.content;
    if (typeof content === 'string') {
      this.editor.options.content = migrateCKEditorHighlights(content);
    }
  },

  onCreate() {
    const original = this.editor.commands.setContent.bind(this.editor.commands);
    this.editor.commands.setContent = (content: any, options?: any) => {
      if (typeof content === 'string') {
        content = migrateCKEditorHighlights(content);
      }
      return original(content, options);
    };
  },
});

function processTextWithAI(text: string): string {
  return text.split('').reverse().join('');
}

function applyAIMagic(editor: any): void {
  const currentText = editor.getText();
  if (!currentText.trim()) return;

  editor.setEditable(false);
  editor.chain().focus().clearContent()
    .insertContent('<p><em>Обработка текста...</em></p>')
    .run();

  of(currentText).pipe(
    delay(2000),
    tap((text) => {
      // const processed = processTextWithAI(text);
      editor.chain().focus().clearContent().insertContent(
        `<p><strong>Ваш обработанный текст:</strong></p>` +
        `<pre><code>${text}</code></pre>` +
        `<p>✨AI АйтиМатерия</p>`
      ).run();
      editor.setEditable(true);
    }),
  ).subscribe();
}

export const tiptapEditorConfig: AteEditorConfig = {
  locale: 'ru',
  height: '400px',
  placeholder: 'Введите ваш текст',
  showWordCount: false,
  showCharacterCount: false,
  showEditToggle: false,
  toolbar: {
    ...ATE_DEFAULT_TOOLBAR_CONFIG,
    clear: true,
    highlight: false,
    image: false,
    link: true,
    alignLeft: true,
    alignCenter: true,
    alignRight: true,
  },
  bubbleMenu: {
    bold: true,
    italic: true,
    underline: true,
    strike: true,
    link: true,
    custom: [
      // {
      //   key: 'reverse-text',
      //   label: 'Перевернуть текст',
      //   icon: 'swap_horiz',
      //   command: (editor: any) => {
      //     const { from, to } = editor.state.selection;
      //     const selectedText = editor.state.doc.textBetween(from, to, '');
      //     if (!selectedText) return;
      //     const reversed = selectedText.split('').reverse().join('');
      //     editor.chain().focus().insertContentAt({ from, to }, reversed).run();
      //   },
      // },
    ],
  },
  floatingToolbar: false,
  slashCommands: {
    heading1: true,
    heading2: true,
    table: true,
    image: false,
    custom: [
      // {
      //   title: 'АйтиМатерия Magic',
      //   description: 'AI-обработка текста',
      //   icon: 'auto_fix',
      //   keywords: ['magic', 'ai'],
      //   command: (editor: any) => applyAIMagic(editor),
      // },
    ],
  },
  tiptapExtensions: [EmptyParagraphPreserver, CKEditorHighlightMigration],
};

export function initTiptapI18n(i18n: AteI18nService): void {
  i18n.addTranslations('ru', RU_TRANSLATIONS);
  i18n.setLocale('ru');
}


